import { style } from '@vanilla-extract/css';

export const dataTableSelectionContainerClass = style({
  flex: 1,
  justifyContent: 'center',
});
